// extracted by mini-css-extract-plugin
export default {"inputbox":"OtpInputContainer_inputbox__KcJ7y"};